import { render, staticRenderFns } from "./UnlockPostWithTokensModal.vue?vue&type=template&id=2bcb635e&scoped=true&"
import script from "./UnlockPostWithTokensModal.vue?vue&type=script&lang=js&"
export * from "./UnlockPostWithTokensModal.vue?vue&type=script&lang=js&"
import style0 from "./UnlockPostWithTokensModal.vue?vue&type=style&index=0&id=2bcb635e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb635e",
  null
  
)

export default component.exports